module.exports = __webpack_public_path__ + "static/media/45.bf4356d1.jpg";